import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useFetch } from "@/hooks/useFetch";
import { Field, inputCls } from "@/components/landing/ProposalForm";
import { QrPoster } from "@/components/panel/QrPoster";

const KEYS = [
  ["pix_key", "Chave Pix", "CPF, CNPJ, e-mail, telefone ou aleatória"],
  ["pix_holder", "Nome do favorecido", "Como aparece no app do banco"],
  ["whatsapp", "WhatsApp de atendimento (aparece no banner do site)", "ex.: (11) 90000-0000"],
  ["contact_email", "E-mail de contato", ""],
  ["instagram", "Instagram", "@eutevila"],
];

export const PanelSettings = () => {
  const { data } = useFetch("/panel/settings", null);
  const { data: pub } = useFetch("/settings/public", {});
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (data) setF(data);
  }, [data]);

  if (!f) return <p className="text-haze">Carregando…</p>;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.put("/panel/settings", f);
      toast.success("Configurações salvas");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="max-w-3xl space-y-6" data-testid="panel-settings">
      <form onSubmit={submit} className="grid gap-4 rounded-[1.5rem] border border-white/10 bg-ink-2 p-6 sm:grid-cols-2">
        {KEYS.map(([k, l, ph]) => (
          <Field key={k} label={l}><input value={f[k] || ""} placeholder={ph} onChange={(e) => setF({ ...f, [k]: e.target.value })} className={inputCls} data-testid={`settings-${k}-input`} /></Field>
        ))}
        <button disabled={busy} className="inline-flex items-center justify-center gap-2 rounded-full bg-flash px-6 py-3 font-semibold text-ink disabled:opacity-60 sm:col-span-2 sm:justify-self-start" data-testid="settings-save-btn">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Salvar
        </button>
      </form>
      <QrPoster path="/eventos" title="Todas as galerias Eutevila" subtitle="Encontre e baixe suas fotos" fileName="eutevila-galerias" testid="site-qr" />
      <div className="rounded-[1.5rem] border border-white/10 p-6" data-testid="settings-mp-status">
        <p className="font-semibold">Mercado Pago</p>
        <p className="mt-1 text-sm text-haze">{pub?.mp_enabled ? "Ativo — clientes podem pagar com cartão, Pix ou saldo pelo Mercado Pago." : "Ainda não ativado. Os clientes podem pagar via Pix com comprovante enquanto isso."}</p>
      </div>
    </div>
  );
};
